import Modal from "react-bootstrap/Modal";
import classNames from "classnames";
import styles from "./default-modal.less";
import { ModalSizeTypes } from "@enums/modal-size-types";
import { ErrorBoundary } from "@containers/common/error-boundary/error-boundary";

type DefaultModalProps = {
    children: React.ReactNode | Array<React.ReactNode>;
    ariaLabelledBy?: string;
    className?: string;
    dialogClassName?: string;
    automationId?: string;
    onHide: () => void;
    size?: ModalSizeTypes;
    keyboard?: boolean;
    onEntered?: () => void;
    backdrop?: "static";
    isMaxWidth: boolean;
};

export const DefaultModal = (props: DefaultModalProps) => {
    const {
        children,
        ariaLabelledBy,
        className,
        dialogClassName,
        automationId,
        onHide,
        size = ModalSizeTypes.LARGE,
        keyboard,
        onEntered,
        backdrop,
        isMaxWidth
    } = props;

    return (
        <ErrorBoundary session={null}>
            <Modal
                automation-id={automationId}
                aria-labelledby={ariaLabelledBy}
                onEntered={onEntered}
                className={className}
                dialogClassName={classNames(dialogClassName, isMaxWidth ? styles.maxWidthModalDialog : "")}
                show={true}
                onHide={onHide}
                //@ts-ignore
                size={size}
                keyboard={keyboard}
                backdrop={backdrop}
            >
                {children}
            </Modal>
        </ErrorBoundary>
    )
};